export function TimeCardService($http, $q, apexApiUrl) {
    'ngInject'
    return {
        retrievePayPeriods: retrievePayPeriods,
        approvePayPeriod: approvePayPeriod
    };

    function retrievePayPeriods(query) {
        if (query.startDate) {
            query.startDate = kendo.format("{0:yyyy-MM-dd}", query.startDate);
        }
        if (query.endDate) {
            query.endDate = kendo.format("{0:yyyy-MM-dd}", query.endDate);
        }
        return $http({
            method: "GET",
            url: apexApiUrl + "pay-periods",
            params: query
        }).then(function (response) {
            return response.data;
        });
    }

    function approvePayPeriod(payPeriodID, approved) {
        return $http({
            method: "PUT",
            url: apexApiUrl + "pay-periods/" + payPeriodID + "/approved",
            headers: { "Content-Type": "application/json" },
            data: approved
        });
    }
}
